module.exports = __webpack_public_path__ + "fd9e603166897d6ce5d1b049fbf0506d.MP3";